import { Box, Breakpoint } from '@mui/material';
import React from 'react';

interface AnchoredImageProps {
  src: string;
  width?: string | number;
  bottom?: string | number;
  right?: string | number;
  top?: string | number;
  left?: string | number;
  zIndex?: number;
  opacity?: number;
  hideBelow?: Breakpoint;
}

export const AnchoredImage: React.FC<AnchoredImageProps> = ({
  src,
  width = '50%',
  bottom,
  right,
  top,
  left,
  zIndex = 0,
  opacity = 0.3,
  hideBelow = 'md',
}) => {
  return (
    <Box
      component="img"
      src={src}
      alt=""
      sx={{
        position: 'absolute',
        width,
        height: 'auto',
        bottom,
        right,
        top,
        left,
        opacity,
        zIndex,
        pointerEvents: 'none',
        display: hideBelow ? { xs: 'none', [hideBelow]: 'block' } : 'block',
      }}
    />
  );
};

export default AnchoredImage;
